import styled, { DefaultTheme, css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { CloseIconButtonProps } from './CloseButon';

const PRESETS = {
  borderRadius: '50%',
  transition: 'all 0.2s ease-in-out',
  beforeBorderRadius: '50%',
  beforeOpacity: 0.45,
  beforeZIndex: -1,
  beforeTransition: 'opacity 0.2s ease-in-out',
  hoverBeforeOpacity: 1,
  transformScale: 1.12,
};

export const StyledCloseButton = styled.div<{
  theme: DefaultTheme;
  type: CloseIconButtonProps['type'];
}>(({ theme, type }) => {
  return css`
    position: relative;
    padding: ${utils.rem(theme.Spacing.Size.XSmall)};
    border-radius: ${PRESETS.borderRadius};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: ${PRESETS.transition};

    ${type === 'floating' &&
    `
      position: absolute;
      top: ${utils.rem(theme.Spacing.Size.XSmall)};
      right: -${utils.rem(theme.Spacing.Size.XXLarge)};
    `};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${theme.Color.Neutrals.Light};
      border-radius: ${PRESETS.beforeBorderRadius};
      opacity: ${PRESETS.beforeOpacity}; /* The initial opacity of the background */
      z-index: ${PRESETS.beforeZIndex}; /* Pseudo-element placed behind the content to control background opacity only */
      transition: ${PRESETS.beforeTransition};
    }

    & i {
      line-height: 0;
    }

    &:hover::before {
      opacity: ${PRESETS.hoverBeforeOpacity}; /* Set the hover opacity to 100% */
    }

    &:hover {
      transform: scale(${PRESETS.transformScale});
    }
  `;
});
